import { incrementTelemetry } from 'core-events/actions';
import noop from 'lodash/noop';
import React, { JSX, useState } from 'react';

import Dropdown from '../../../../components/components/elements/Dropdown';
import { ContentTypes, ContentTypesWithSnapshots } from './ContentTypes';

import './navSearchDropdown.css';

const COMPACT_BUTTON_CLASSES =
    'flex justify-center items-center bg-gray-900 hover:bg-black z-10 whitespace-nowrap text-sm font-semibold cursor-pointer rounded-full h-8 px-4 text-white gap-1.5 border border-solid border-gray-900';

export default function NavSearchDropdown({
    onChange = noop,
    value = '',
    useSnapshots = false,
    compact = false,
}: {
    onChange: (value: string) => void;
    value: string;
    useSnapshots?: boolean;
    compact?: boolean;
}): JSX.Element {
    const [isOpen, setIsOpen] = useState(false);
    const options = useSnapshots ? ContentTypesWithSnapshots : ContentTypes;

    const dropdownToggle = () => {
        setIsOpen((prev) => !prev);
    };

    const dropdownClose = () => {
        setIsOpen(false);
    };

    const dropdownSelect = (value: string) => {
        onChange(value);
        void incrementTelemetry(`nav.search.${value}`);
        dropdownClose();
    };

    return (
        <Dropdown
            options={options}
            value={value}
            isOpen={isOpen}
            onToggle={dropdownToggle}
            onClose={dropdownClose}
            onSelect={dropdownSelect}
            buttonClassName={compact ? COMPACT_BUTTON_CLASSES : undefined}
            hideLabelIcon={compact}
        />
    );
}
